<div class="trial-counter-trial-block" [ngStyle]="{ 'width' : trialStatus.blockWidth, 'height' : trialStatus.blockHeight }">
  <div class="trial-chip-container">
    <div class="trial-counter-space" [ngClass]="trialStatus.class" [ngStyle]="{ 'margin-left' : trialStatus.leftMargin, 'width' : trialStatus.chipWidth, 'height' : trialStatus.chipHeight }"></div>
  </div>
</div>
